import { handleActions } from 'redux-actions';
import { setPrimaryDoctor } from './actions';

const defaultState = {
  addressId: undefined,
  addressState: '',
  city: '',
  email: '',
  phoneExtension: '',
  fax: '',
  firstName: '',
  id: undefined,
  lastName: '',
  otherContacts: [],
  practiceName: '',
  primaryPhoneNumber: '',
  secondaryStreetAddress: '',
  streetAddress: '',
  url: '',
  zipCode: '',
  notes: '',
};

const reducer = handleActions(
  {
    [setPrimaryDoctor]: (state, action) => {
      const primaryDoctor = action.payload;
      return {
        ...state,
        ...primaryDoctor,
      };
    },
  },
  defaultState,
);

export default reducer;



// WEBPACK FOOTER //
// ./src/lib/dataLayer/primaryDoctor/reducer.js